/** Tipografia legível — marketplace canabinoide (acessibilidade). */
export const marketplaceTypography = {
  /** Texto principal — mínimo ~16px */
  body: { fontSize: "1rem", lineHeight: 1.5 },
  /** Texto secundário — ~15px */
  bodySecondary: { fontSize: "0.9375rem", lineHeight: 1.45 },
  /** Rótulos e nomes em destaque */
  label: { fontSize: "1.0625rem", fontWeight: 700, lineHeight: 1.4 },
  /** Preços */
  price: { fontSize: "1.0625rem", fontWeight: 700, lineHeight: 1.3 },
  /** Títulos de seção */
  sectionTitle: { fontSize: "1.125rem", fontWeight: 700, lineHeight: 1.35 },
  /** Título da página */
  pageTitle: { fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.3 },
  /** Campo de busca / inputs */
  input: { fontSize: "1rem" },
  /** Botões compactos em cards */
  button: { fontSize: "0.9375rem", fontWeight: 700 },
} as const;
